import React from 'react';
import ReactPlayer from 'react-player';
import { StarIcon } from 'lucide-react';
export function TestimonialSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-orange-100" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-151">
          <div className="inline-flex items-center justify-center gap-1 mb-4 sm:mb-6" data-id="element-152">
            <StarIcon className="h-6 w-6 sm:h-8 sm:w-8 text-orange-600 fill-orange-600" data-id="element-153" />
            <StarIcon className="h-6 w-6 sm:h-8 sm:w-8 text-orange-600 fill-orange-600" data-id="element-154" />
            <StarIcon className="h-6 w-6 sm:h-8 sm:w-8 text-orange-600 fill-orange-600" data-id="element-155" />
            <StarIcon className="h-6 w-6 sm:h-8 sm:w-8 text-orange-600 fill-orange-600" data-id="element-156" />
            <StarIcon className="h-6 w-6 sm:h-8 sm:w-8 text-orange-600 fill-orange-600" data-id="element-157" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight px-2" data-id="element-158">
            Historias de éxito de nuestros miembros
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto px-4" data-id="element-159">
            Cómo pasaron de cero a un funnel que vende 24/7
          </p>
        </div>
        <div className="max-w-4xl mx-auto space-y-6 sm:space-y-8 md:space-y-10" data-id="element-160">
          <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-161">
            <div className="aspect-video" data-id="element-162">
              <ReactPlayer url="https://youtu.be/Th7pH9-tzgo" width="100%" height="100%" controls data-id="element-163" />
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-164">
            <div className="aspect-video" data-id="element-165">
              <ReactPlayer url="https://youtu.be/NNqL6PGZg6Y" width="100%" height="100%" controls data-id="element-166" />
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-167">
            <div className="aspect-video" data-id="element-168">
              <ReactPlayer url="https://youtu.be/KYPBmRxWqOU" width="100%" height="100%" controls data-id="element-169" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}